
import axios from "./axios";
const moduleFetch = {
  test(data) {
    return axios.post("/api/", data);
  },
};
export default moduleFetch;
